// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateClaimsStatus = (status, isSelected) =>
    dispatch => {

        dispatch({
            data: false,
            type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
        });

        dispatch({
            isSelected,
            status,
            type: actions.UPDATE_USER_PREFERENCES_CLAIMS_STATUS
        });

    };

export const updateClaimsNumberOfDays = numberOfDays =>
    dispatch => {

        dispatch({
            data: false,
            type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
        });

        dispatch({
            numberOfDays,
            type: actions.UPDATE_USER_PREFERENCES_CLAIMS_NUMBER_OF_DAYS
        });

    };

export const toggleAllClaimStatus = statusList =>
    dispatch => {

        dispatch({
            data: false,
            type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
        });

        dispatch({
            statusList,
            type: actions.UPDATE_USER_PREFERENCES_ALL_CLAIMS_STATUS
        });

    };



// WEBPACK FOOTER //
// ./src/user/shared/action-creators/claims-settings.js